import { render } from "./dropdown_normal.vue?vue&type=template&id=5073d740&scoped=true"
import script from "./dropdown_normal.vue?vue&type=script&lang=js"
export * from "./dropdown_normal.vue?vue&type=script&lang=js"

import "./dropdown_normal.vue?vue&type=style&index=0&id=5073d740&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5073d740"]])

export default __exports__